export enum SelectionType {
  NONE = 0,
  HOME_WIN = 1,
  AWAY_WIN = 2,
  TIE = 3,
  HOME_WIN_OVERTIME = 4,
  HOME_WIN_SHOOTOUT = 5,
  AWAY_WIN_OVERTIME = 6,
  AWAY_WIN_SHOOTOUT = 7,
}
